import React, { useState } from 'react';
import { FadeIn } from '../ui/FadeIn';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export function FAQSection() {
  const faqs = [{
    q: 'Do I need to buy special supplements?',
    a: 'No. Everything you need is in a standard Australian grocery store: lemons, sea salt, ginger, and basic vegetables.'
  }, {
    q: 'Can I drink coffee?',
    a: 'Yes, we have a specific protocol for how to drink coffee without triggering a bloat response.'
  }, {
    q: 'Is this a fast?',
    a: 'No. You will eat three full, warm, delicious meals a day. We are focused on what you eat, not starving you.'
  }, {
    q: 'How long do the results last?',
    a: 'This is a "Visual Reset" for an event. It lasts as long as you avoid your primary triggers, and we include a maintenance guide to help you stay lean.'
  }];
  return <section className="py-16 px-6 max-w-2xl mx-auto" data-id="element-32">
      <FadeIn data-id="element-33">
        <h2 className="font-serif text-3xl md:text-4xl text-charcoal mb-10 text-center leading-tight" data-id="element-34">
          Frequently Asked Questions
        </h2>

        <div className="space-y-4" data-id="element-35">
          {faqs.map((faq, index) => <FAQItem key={index} question={faq.q} answer={faq.a} data-id="element-36" />)}
        </div>
      </FadeIn>
    </section>;
}
function FAQItem({
  question,
  answer
}: {
  question: string;
  answer: string;
}) {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="border border-sage/20 rounded-xl bg-white overflow-hidden" data-id="element-37">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full flex items-center justify-between p-5 text-left focus:outline-none" aria-expanded={isOpen} data-id="element-38">
        <span className="font-sans font-medium text-charcoal pr-4" data-id="element-39">
          {question}
        </span>
        <ChevronDown className={`w-5 h-5 text-sage transition-transform duration-300 flex-shrink-0 ${isOpen ? 'rotate-180' : ''}`} data-id="element-40" />
      </button>
      <AnimatePresence data-id="element-41">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3,
        ease: 'easeInOut'
      }} data-id="element-42">
            <div className="p-5 pt-0 text-charcoal-light font-sans leading-relaxed border-t border-sage/10" data-id="element-43">
              {answer}
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}